module.exports = __webpack_public_path__ + "img/cases-brand-avic-12.82e162a6.jpg";